interface Props {
  blur?: boolean
}

export default function SavingsSVG({ blur }: Readonly<Props>) {
  return (
    <svg
      role="img"
      aria-label="Slantar som trillar ner i en sparbössa"
      width="109"
      height="150"
      viewBox="0 0 109 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="px-6 py-3 sm:p-0"
    >
      <title>Slantar som trillar ner i en sparbössa</title>
      <g clipPath="url(#clip0_44_3471)">
        <path
          d="M54.1043 83.2109C54.1043 97.1152 65.3325 108.387 79.1856 108.387C93.0379 108.387 104.268 97.1152 104.268 83.2109C104.268 69.3066 93.0379 58.0345 79.1856 58.0345C65.3325 58.0345 54.1043 69.3066 54.1043 83.2109Z"
          fill={blur ? '#E6E6E6' : '#FF620F'}
        />
        <path
          d="M48.1963 50.6861C62.0488 50.6861 73.2784 39.4143 73.2784 25.5097C73.2784 11.6052 62.0488 0.333374 48.1963 0.333374C34.3439 0.333374 23.1142 11.6052 23.1142 25.5097C23.1142 39.4143 34.3439 50.6861 48.1963 50.6861Z"
          fill={blur ? '#E6E6E6' : '#FF620F'}
        />
        <path
          d="M64.0284 126.228C64.0515 125.797 64.0828 125.368 64.0828 124.931C64.0828 111.026 52.853 99.7546 39.0015 99.7546C25.1492 99.7546 13.9194 111.026 13.9194 124.931C13.9194 125.221 13.9455 125.506 13.956 125.794L0.865579 125.681L0.666668 148.733L108.469 149.667L108.667 126.616L64.0284 126.228Z"
          fill={blur ? '#E6E6E6' : '#FF620F'}
        />
      </g>
      <defs>
        <clipPath id="clip0_44_3471">
          <rect
            width="108"
            height="149.333"
            fill="white"
            transform="translate(0.666668 0.333374)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
